exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-microcart-icon[data-v-92f7cf02]{position:relative}.a-microcart-icon .sf-header__icon[data-v-92f7cf02]{cursor:pointer}\n", ""]);

// exports
